<template>
  <div class="container">
    <div
      class="wrap"
      v-if="ItemObject"
    >
      <div class="title">{{ItemObject.title}}</div>
      <div class="cont">考试说明：{{ItemObject.des}}</div>
      <div class="time">
        <span>开始时间：{{formatTime(ItemObject.startTime)}}</span>
        <span style="margin-left: 20px;">结束时间：{{formatTime(ItemObject.endTime)}}</span>
        <span style="margin-left: 20px;">显示成绩时间：{{formatTime(ItemObject.answerTime)}}</span>
      </div>
      <div
        class="cont"
        v-if="getNowTime() > formatTime(ItemObject.answerTime) && formatTimeStatus(ItemObject) == 3"
      >
        您的成绩：{{GradeObject ? GradeObject.grade : ''}}
      </div>
      <div v-if="ItemObject && formatTimeStatus(ItemObject) == 1">
        考试未开始
      </div>
      <button
        v-if="ItemObject && (formatTimeStatus(ItemObject) == 2 || formatTimeStatus(ItemObject) == 0)"
        @click="toTest"
      >去做测试</button>
      <div v-if="ItemObject && formatTimeStatus(ItemObject) == 3">
        考试已结束
        <button @click="viewResult">查看试卷</button>
      </div>

    </div>
    <div
      v-else
      style="color:#666;margin-top:200px;text-align:center"
    >
      暂无内容
    </div>
    <ExamResult
      :show="onlineStudentExamShow"
      :id="onlineStudentExamId"
      :closeExamResultWindow="closeViewResult"
    ></ExamResult>
  </div>
</template>

<script>
import ExamResult from '../ExamResult'

export default {
  components: {
    ExamResult
  },
  props: {
    ItemObject: Object
  },
  data () {
    return {
      GradeObject: null,
      onlineStudentExamId: 0,
      onlineStudentExamShow: false
    }
  },
  methods: {
    async toTest () {
      const checkExamData = await this.$http.get('/online_student_exam/', {
        params: {
          onlineExam_id: this.ItemObject.id,
          onlineStudent_id: this.$route.query.studentId
        }
      })

      if (checkExamData.results.length > 0) {
        this.$layer.msg('您已经提交过考试，不能再次提交！')
        return false
      }

      const path = '/my/lesson/test?id=' + this.ItemObject.lessonOnline_id + '&TestId=' + this.ItemObject.id + '&&studentId=' + this.$route.query.studentId
      this.$router.push(path)
    },
    formatTime(val) {
      if (!val) {
        return ''
      }
      return val.replace('T', ' ')
    },
    addZero(s) {
      return s < 10 ? ('0' + s) : s
    },
    getNowTime () {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hour = date.getHours()
      const minute = date.getMinutes()
      const second = date.getSeconds()
      const time = '' + year + '-' + this.addZero(month) + '-' + this.addZero(day) + ' ' + this.addZero(hour) + ':' + this.addZero(minute) + ':' + this.addZero(second)
      return time
    },
    formatTimeStatus (item) {
      if (!item.startTime || !item.endTime) {
        return 0
      }
      const curTime = this.getNowTime()
      if (item.startTime.replace('T', ' ') > curTime) {
        return 1
      }
      if (curTime >= item.startTime.replace('T', ' ') && item.endTime.replace('T', ' ') >= curTime) {
        return 2
      }
      if (curTime > item.endTime.replace('T', ' ')) {
        return 3
      }
      return 0
    },
    async viewResult () {
      const checkExamData = await this.$http.get('/online_student_exam/', {
        params: {
          onlineExam_id: this.ItemObject.id,
          onlineStudent_id: this.$route.query.studentId
        }
      })

      if (checkExamData.results.length === 0) {
        this.$layer.msg('您未提交过考试！')
        return false
      }

      this.onlineStudentExamId = checkExamData.results[0].id
      this.onlineStudentExamShow = true
    },
    closeViewResult () {
      this.onlineStudentExamShow = false
    }
  },
  async mounted() {
    const examData = await this.$http.get('/online_student_exam/', {
      params: {
        onlineExam_id: this.ItemObject.id,
        onlineStudent_id: this.$route.query.studentId
      }
    })

    if (examData.results.length > 0) {
      this.GradeObject = examData.results[0]
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 10px;
}
.wrap {
  .title {
    font-size: 16px;
    margin: 15px 0;
    display: inline-block;
    color: #333;
  }
  .cont {
    padding: 20px 0;
    line-height: 22px;
    color: #666666;
  }
  .time {
    padding: 15px 0;
    color: #999999;
    border-top: 1px solid #eee;
    font-size: 12px;
  }
  .toPage {
    color: #337ab7;
    &:hover {
      text-decoration: underline;
    }
  }
  button {
    font-size: 16px;
    background: #4977e9;
    color: #fff;
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
  }
}
</style>
